import React from 'react';
import ConfigurationEditPage from '../configuration/ConfigurationEditPage';
import SetProductSerialNumberModal from './modals/SetProductSerialNumberModal';

export default class ProjectConfigurationPage extends ConfigurationEditPage {

    constructor(props) {
        super(props);

        this.state.setSerialNumberModal = false
    }

    renderModals() {
        return (
            <React.Fragment>
                <SetProductSerialNumberModal
                    productSerialNumber={this.props.productSerialNumber}
                    configurationId={this.props.id.value}
                    projectId={this.props.projectId}
                    visible={this.state.setSerialNumberModal}
                    onClose={this.onProductSerialNumberCloseClick}
                    onSuccess={this.onProductSerialNumberCloseClick}
                />
            </React.Fragment>
        )
    }

    onSetSerialNumberClick = () => this.setState({setSerialNumberModal: true});

    onProductSerialNumberCloseClick = () => this.setState({setSerialNumberModal: false});
}